import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const RunCostPage = lazy(() => import('~/features/catalog-enrichment/pages/run-cost-page'));

/** A batch's Cost tab — spend against the estimate, where it went, and its approval. */
export const Route = createFileRoute('/_authenticated/_tenant/catalog-enrichment/runs/$runId/cost')(
  {
    component: RouteComponent,
  },
);

function RouteComponent() {
  const { runId } = Route.useParams();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <RunCostPage runId={runId} />
    </Suspense>
  );
}
